import { render, staticRenderFns } from "./sale.vue?vue&type=template&id=1a05fda0&scoped=true"
import script from "./sale.vue?vue&type=script&lang=js"
export * from "./sale.vue?vue&type=script&lang=js"
import style0 from "./sale.vue?vue&type=style&index=0&id=1a05fda0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a05fda0",
  null
  
)

export default component.exports